// export default {
//   baseURL: 'http://localhost:8000',
//   storageURL: 'http://localhost:8000/storage/uploads/',
// }

export default {
  baseURL: 'https://agentconnect-plus.com',
  storageURL: 'https://agentconnect-plus.com/storage/uploads/',
}